import { render } from "./skillsChart.vue?vue&type=template&id=7507479e&scoped=true"
import script from "./skillsChart.vue?vue&type=script&lang=js"
export * from "./skillsChart.vue?vue&type=script&lang=js"

import "./skillsChart.vue?vue&type=style&index=0&id=7507479e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7507479e"]])

export default __exports__